import sortBy from 'lodash/sortBy';

import TeachingLearningSequenceIntroductionView from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence-introduction-view';
import TeachingLearningSequenceQuestionsView from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence-questions-view';
import TeachingLearningSequenceActivity from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence-activity';
import {
  CONTENT_OBJECT_TYPE_LESSON,
  LESSON,
  ASSESSMENT,
} from 'global/constants';
import { TeachingAndLearningSequence } from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence.constants';
import { InteractiveLessonSectionOverview } from 'approot/activity-builder/__generated__/InteractiveLessonSectionOverview';
import TeachingLearningSequencePaywall from 'approot/shared/teaching-learning-sequence/teaching-learning-sequence-paywall';
import { TeachingLearningSequenceGuestGradient } from './teaching-learning-sequence-guest.style';
import { TeachingLearningSequence } from 'approot/activity-builder/components/teaching-notes/__generated__/TeachingLearningSequence';

const TeachingLearningSequenceGuest = ({
  sequences,
  activitySequences,
  isSmall,
  sectionsOverview,
  isAccountExpired,
  totalGreenActivities,
  totalBlueActivities,
  totalBlackActivities,
  totalStimulus,
  contentId,
  contentType,
}: {
  sequences: TeachingAndLearningSequence[] | null;
  activitySequences: TeachingLearningSequence[] | null;
  isSmall?: boolean;
  sectionsOverview: InteractiveLessonSectionOverview[] | null | undefined;
  isAccountExpired: boolean;
  totalGreenActivities: number;
  totalBlueActivities: number;
  totalBlackActivities: number;
  totalStimulus: number;
  contentId: number;
  contentType: typeof LESSON | typeof ASSESSMENT;
}) => {
  return (
    <>
      <TeachingLearningSequenceGuestGradient>
        <TeachingLearningSequenceIntroductionView
          isSmall={isSmall}
          sequences={sequences}
          contentType={CONTENT_OBJECT_TYPE_LESSON}
        />
        {sectionsOverview ? (
          <TeachingLearningSequenceActivity
            isSmall={isSmall}
            index={0}
            sequences={activitySequences}
            section={sortBy(sectionsOverview, 'sort')?.[0]}
          />
        ) : (
          <TeachingLearningSequenceQuestionsView
            isSmall={isSmall}
            sequences={sequences}
          />
        )}
      </TeachingLearningSequenceGuestGradient>

      <TeachingLearningSequencePaywall
        isAccountExpired={isAccountExpired}
        totalGreenActivities={totalGreenActivities}
        totalBlueActivities={totalBlueActivities}
        totalBlackActivities={totalBlackActivities}
        totalStimulus={totalStimulus}
        contentId={contentId}
        contentType={contentType}
      />
    </>
  );
};

export default TeachingLearningSequenceGuest;
